var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#233737",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3485_17878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 5.3335L13.3335 7.3335M13.3335 7.3335L11.3335 9.3335M13.3335 7.3335H8.5335C7.41339 7.3335 6.85334 7.3335 6.42552 7.55148C6.04919 7.74323 5.74323 8.04919 5.55148 8.42551C5.3335 8.85334 5.3335 9.41339 5.3335 10.5335V14.3335C5.3335 14.6431 5.3335 14.7979 5.35061 14.9279C5.46876 15.8253 6.17498 16.5316 7.07244 16.6497C7.20241 16.6668 7.35722 16.6668 7.66683 16.6668M10.6668 16.6668H15.4668C16.5869 16.6668 17.147 16.6668 17.5748 16.4488C17.9511 16.2571 18.2571 15.9511 18.4488 15.5748C18.6668 15.147 18.6668 14.5869 18.6668 13.4668V9.66683C18.6668 9.35722 18.6668 9.20241 18.6497 9.07244C18.5316 8.17498 17.8253 7.46876 16.9279 7.35061C16.7979 7.3335 16.6431 7.3335 16.3335 7.3335M10.6668 16.6668L12.6668 18.6668M10.6668 16.6668L12.6668 14.6668",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3485_17878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepost);
export default __webpack_public_path__ + "static/media/repost.01202c50060176be71fe3c7ffb8be75a.svg";
export { ForwardRef as ReactComponent };